import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TagManager from 'react-gtm-module';
import Dialog from '@material-ui/core/Dialog';
import { withRouter } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { constructGTM } from '../../utilities/helpers';

import styles from './styles';
import bg from './images/bg.jpg';
import JHLogoIcon from '../JHLogoIcon';
import { closeModal } from '../../store/actions/modal';
import JHTextLogoFullColour from '../JHTextLogoFullColour';
import RegistrationForm from './components/RegistrationForm';
import { REGISTRATION_MODAL_REFERRER } from '../../constants';
import { setRegistrationInfo } from '../../store/actions/registration';

const propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    leftPanel: PropTypes.string,
    rightPanel: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  referrer: PropTypes.oneOf([
    REGISTRATION_MODAL_REFERRER.LINK,
    REGISTRATION_MODAL_REFERRER.LOGIN_FAILURE,
  ]).isRequired,
  fullScreen: PropTypes.bool.isRequired,
  onSetRegistrationInfo: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export const RegistrationModal = props => {
  const {
    history,
    classes,
    onClose,
    isOpen,
    fullScreen,
    referrer,
    onSetRegistrationInfo,
    onCloseModal,
  } = props;

  const handleFormSubmit = values => {
    onSetRegistrationInfo(values);
    // Log submit event to GTM
    TagManager.initialize(
      constructGTM({
        dataLayer: {
          event: 'registration_myhardies',
          step: 'Your Details',
          stepcnt: '1',
        },
      }),
    );

    onCloseModal();
    history.push('/registration');
  };

  const getFormTopContent = () => {
    if (referrer === REGISTRATION_MODAL_REFERRER.LINK) {
      return (
        <>
          <h3 className={classes.headingText}>Apply for a myHardies Account</h3>
          <div className={classes.normalText}>
            Please complete the details below.
          </div>
        </>
      );
    }

    return (
      <div className={classes.normalText}>
        Your email address is not registered. Please complete the form below to
        apply for a myHardies account
      </div>
    );
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      onClose={onClose}
      disableBackdropClick
      aria-labelledby="Registration Modal"
      open={isOpen}
      maxWidth="md"
      fullWidth
      classes={{
        paper: classes.modalPaper,
      }}
    >
      <div className={classes.root}>
        <IconButton
          aria-label="Close"
          className={classes.topCloseButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <div className={classes.inner}>
          <div
            className={classes.leftPanel}
            style={{ backgroundImage: `url(${bg})` }}
          >
            <JHTextLogoFullColour />
          </div>
          <div className={classes.rightPanel}>
            <Toolbar className={classes.toolBar}>
              <JHLogoIcon />
            </Toolbar>
            <div className={classes.rightPanelContent}>
              <div className={classes.formTopContentContainer}>
                {getFormTopContent()}
              </div>
              <RegistrationForm
                onCancel={onClose}
                onSubmit={handleFormSubmit}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

RegistrationModal.propTypes = propTypes;

const mapDispatchToProps = dispatch => ({
  onSetRegistrationInfo: info => dispatch(setRegistrationInfo(info)),
  onCloseModal: () => dispatch(closeModal()),
});

const styledRegistrationModal = withStyles(styles)(
  withMobileDialog()(
    connect(
      null,
      mapDispatchToProps,
    )(withRouter(RegistrationModal)),
  ),
);
styledRegistrationModal.displayName = 'styledRegistrationModal';

export default styledRegistrationModal;
